module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-up-short-0ea5cbdd.svg";